export const GET_CANDIDATE_RESIT_TRANSACTION = '/candidate/transaction-info';
export const GET_RESIT_RECEIPT_SUMMARY = '/receipt/summary';

export const GET_RESIT_CANDIDATE_DOWNLOAD_SUMMARY = (internalTransactionRef: string) =>
  `/candidate/receipt/download/${internalTransactionRef}`;
